import { useEffect, useState } from "react";
import {
  Paper, Tooltip, Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, withStyles, createStyles, Theme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import clsx from "clsx";
import { useDispatch } from "react-redux";
import { saveUserFilter } from "../../store/actions/createUpdateEnquiry.actions";

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: "14px",   // increase text size
  },
  yes: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#1A9FE0',
    textTransform: 'capitalize'
  },
  cancel: {
    fontSize: '0.813rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    color: '#919191',
    textTransform: 'capitalize'
  },
  resetText: {
    color: '#616161',
    fontSize: '0.875rem',
    fontFamily: 'Nunito',
    fontWeight: 700,
    textTransform: 'inherit'
  },
  header: {
    color: '#616161',
    fontSize: '1.5rem',
    fontFamily: 'Nunito',
    fontWeight: 800,
    textTransform: 'inherit'
  },
  formContainer: {
    margin: "10px 0",
  },
  selectInput: {
    margin: "15px 0",
  },
  saveButton: {
    backgroundColor: "#1A9FE0",
    width: 180,
    fontWeight: 800,
    fontFamily: "Nunito",
    fontSize: "0.688rem",
    color: "#FFFFFF",
    borderRadius: "2.5rem",
    height: 35,
    textAlign: "center",
    cursor: "pointer",
    marginRight: 8,
    "& .MuiButton-label": {
      textTransform: "none",
    },
  },
  resetButton: {
    backgroundColor: "grey",
    width: 140,
    fontWeight: 800,
    textTransform: "capitalize",
    fontFamily: "Nunito",
    fontSize: "0.688rem",
    color: "#FFFFFF",
    borderRadius: "2.5rem",
    height: 35,
    cursor: "pointer",
    textAlign: "center",
    "&:hover": {
      backgroundColor: "grey", // lighter grey for hover
    },
  },
  toggleSwitch: {
    display: "flex",
    alignItems: "center",
    margin: "15px 0",
  },
}));

const AntSwitch = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 60,
      height: 28,
      padding: 0,
    },
    switchBase: {
      padding: 5,
      color: "#FFFFFF",
    },
    thumb: {
      width: 17,
      height: 17,
    },
    track: {
      background: "#444444",
      opacity: "1 !important",
      borderRadius: "2rem",
      position: "relative",
      "&:before, &:after": {
        display: "inline-block",
        position: "absolute",
        top: "50%",
        width: "50%",
        transform: "translateY(-50%)",
        color: "#FFFFFF",
        textAlign: "center",
        fontSize: 10,
        fontFamily: "Nunito",
        fontWeight: 500,
      },
      "&:before": {
        content: '"Yes"',
        left: 7,
        opacity: 0,
      },
      "&:after": {
        content: '"No"',
        right: 6,
      },
    },
    checked: {
      "&$switchBase": {
        color: "#FFFFFF",
        transform: "translateX(33px)",
      },
      "& $thumb": {
        backgroundColor: "#FFFFFF",
      },
      "& + $track": {
        "&:before": {
          opacity: 1,
        },
        "&:after": {
          opacity: 0,
        },
      },
    },
  })
)(Switch);

export default function FilterMenu(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { profileDetails, rowSummaryGlobalData, annexureEnquiry } = props;

  const COLUMNS = ["Price", "Availability", "Dimension", "Volume"];
  const PRICES = ["NSP (Incl. VAT)", "Amt", "NSP (Excl. VAT)", "BOP", "RSP"];
  const AVAILABILITY = ["NOW", "BO", "24Hrs"];
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false); // Close popup on cancel
  };



  let BRANDS: string[] = [];
  if (props.rowSummaryGlobalData?.length > 0) {
    BRANDS = props.rowSummaryGlobalData.map((item: any) => item.brandNameInfo);
  }

  const filteredPrices = props.annexureEnquiry
    ? PRICES.filter((p) => p !== "BOP" && p !== "RSP")
    : PRICES;

  let filteredAvailability;

  if (props.annexureEnquiry) {
    filteredAvailability = AVAILABILITY.filter((a) => a !== "BO" && a !== "24Hrs");
  } else if (props.isHide24hrs) {
    filteredAvailability = AVAILABILITY.filter((a) => a !== "24Hrs");
  } else {
    filteredAvailability = AVAILABILITY;
  }


  const [columns, setColumns] = useState<string[]>(props.columnPreferences.visibleColumns || COLUMNS);
  const [brands, setBrands] = useState<string[]>(props.columnPreferences.brandFilter || BRANDS);
  const [price, setPrice] = useState<string[]>(props.columnPreferences.priceColumnVisibility || filteredPrices);
  const [availability, setAvailability] = useState<string[]>(props.columnPreferences.availabilityColumnVisibility || filteredAvailability);
  const [showAlternate, setShowAlternate] = useState<boolean>(
    props.columnPreferences.alternatePartsToggle ?? true
  );

  const [showAlternateBtn, setShowAlternateBtn] = useState(true);

  const renderDropdown = (label: string, value: any[], setValue: any, options: any[]) => {
    let isAllSelected = value.length === options.length;
    if (label === "Brand" && value.every((item) => item === "Brand")) {
      isAllSelected = false;
    }
    // 🧹 Clean value for Price dropdown
    let filteredValue = value;
    if (label === "Price" && annexureEnquiry) {
      filteredValue = value.filter((v) => v !== "BOP" && v !== "RSP");
    }

    const handleChange = (event: any) => {
      const { value: selected } = event.target;
      let val: string[];
      if (selected.includes("all") || selected.length === 0) {
        val = isAllSelected || selected.length === 0 ? ["Brand"] : options;
        setValue(val);
      } else {
        val = typeof selected === "string" ? selected.split(",") : selected;
        setValue(val);
      }

      props.onApplyFilter({
        visibleColumns: label === "Column" ? val : columns,
        brandFilter: label === "Brand" ? val : brands,
        priceColumnVisibility: label === "Price" ? val : price,
        availabilityColumnVisibility: label === "Availability" ? val : availability,
        alternatePartsToggle: showAlternate,
      });
    };

    return (
      <FormControl
        fullWidth
        size="small"
        variant="outlined"
        className={clsx("rounded-input-dealer w-100", classes.selectInput)}
      >
        <InputLabel>{label}</InputLabel>
        <Select
          multiple
          value={filteredValue.filter((v) => v !== "Brand")}
          onChange={handleChange}
          input={<OutlinedInput label={label} />}
          renderValue={(selected: any) => selected.join(", ")}
          MenuProps={{
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
            getContentAnchorEl: null,
          }}
        >
          <MenuItem value="all">
            <Checkbox checked={isAllSelected} indeterminate={value.length > 0 && value.length < options.length} />
            <ListItemText primary={isAllSelected ? "Deselect All" : "Select All"} />
          </MenuItem>
          {options
            .filter((option) => option !== "Brand")
            .map((option) => (
              <MenuItem key={option} value={option}>
                <Checkbox checked={filteredValue.indexOf(option) > -1} />
                <ListItemText primary={option} />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  };

  const savePreferences = async () => {
    let userId = "";
    const userData = props?.profileDetails?.data?.data?.basicInfo;

    if (userData.userType === "FSE") {
      userId = userData?.webApplicationLoginId;
    } else {
      userId = userData?.b2bUserId;
    }

    const payload = {
      userId,
      enquiryGridPreferences: {
        visibleColumns: columns,
        brandFilter: brands,
        priceColumnVisibility: price,
        availabilityColumnVisibility: availability,
        alternatePartsToggle: showAlternate,
      },
    };

    const userFilterData: any = await dispatch(saveUserFilter(payload));
    props.onApplyFilter(payload.enquiryGridPreferences);
    props.hideFilterMenu(userFilterData);
  };

  // useEffect(() => {
  // setColumns(props.columnPreferences.visibleColumns || COLUMNS);
  // setBrands(props.columnPreferences.brandFilter || BRANDS);
  // setPrice(props.columnPreferences.priceColumnVisibility || filteredPrices);
  // setAvailability(props.columnPreferences.availabilityColumnVisibility || filteredAvailability);
  // setShowAlternate(props.columnPreferences.alternatePartsToggle ?? true);

  useEffect(() => {
    if (profileDetails?.data?.data?.basicInfo) {
      const prefs = props.columnPreferences ? props.columnPreferences : profileDetails.data.data.basicInfo.enquiryGridPreferences;

      const COLUMNS = ["Price", "Availability", "Dimension", "Volume"];
      const PRICES = ["NSP (Incl. VAT)", "Amt", "NSP (Excl. VAT)", "BOP", "RSP"];
      const AVAILABILITY = ["NOW", "BO", "24Hrs"];

      let BRANDS: string[] = [];
      if (rowSummaryGlobalData?.length > 0) {
        BRANDS = rowSummaryGlobalData.map((item: any) => item.brandNameInfo);
      }

      const filteredPrices =
        annexureEnquiry === "true"
          ? PRICES.filter((p) => p !== "BOP" && p !== "RSP")
          : PRICES;

      const filteredPrefs =
        prefs?.priceColumnVisibility?.length > 0
          ? annexureEnquiry === "true"
            ? prefs.priceColumnVisibility.filter((p: any) => p !== "BOP" && p !== "RSP")
            : prefs.priceColumnVisibility
          : [];

      let filteredAvailability;

      if (props.annexureEnquiry) {
        filteredAvailability = AVAILABILITY.filter((a) => a !== "BO" && a !== "24Hrs");
      } else if (props.isHide24hrs) {
        filteredAvailability = AVAILABILITY.filter((a) => a !== "24Hrs");
      } else {
        filteredAvailability = AVAILABILITY;
      }

      let filteredPrefsAvailability = [];

      if (prefs?.availabilityColumnVisibility?.length > 0) {
        if (props.annexureEnquiry) {
          filteredPrefsAvailability = prefs.availabilityColumnVisibility.filter(
            (a: any) => a !== "BO" && a !== "24Hrs"
          );
        } else if (props.isHide24hrs) {
          filteredPrefsAvailability = prefs.availabilityColumnVisibility.filter(
            (a: any) => a !== "24Hrs"
          );
        } else {
          filteredPrefsAvailability = prefs.availabilityColumnVisibility;
        }
      }


      setColumns(prefs?.visibleColumns?.length > 0 ? prefs.visibleColumns : COLUMNS);
      setBrands(prefs?.brandFilter?.length > 0 ? prefs.brandFilter : BRANDS);
      setPrice(prefs?.priceColumnVisibility?.length > 0
        ? filteredPrefs
        : filteredPrices);
      setAvailability(prefs?.availabilityColumnVisibility?.length > 0
        ? filteredPrefsAvailability
        : filteredAvailability);
      setShowAlternate(prefs?.alternatePartsToggle !== undefined
        ? prefs.alternatePartsToggle
        : true);
    }
  }, [props.columnPreferences, profileDetails]);


  // }, [props.columnPreferences, filteredPrices, filteredAvailability]);


  const resetPreference = () => {
    const COLUMNS = ["Price", "Availability", "Dimension", "Volume"];
    const PRICES = ["NSP (Incl. VAT)", "Amt", "NSP (Excl. VAT)", "BOP", "RSP"];
    const AVAILABILITY = ["NOW", "BO", "24Hrs"];

    let BRANDS: string[] = [];
    if (rowSummaryGlobalData?.length > 0) {
      BRANDS = rowSummaryGlobalData.map((item: any) => item.brandNameInfo);
    }

    const filteredPrices =
      annexureEnquiry === "true"
        ? PRICES.filter((p) => p !== "BOP" && p !== "RSP")
        : PRICES;

    let filteredAvailability;

    if (props.annexureEnquiry) {
      filteredAvailability = AVAILABILITY.filter((a) => a !== "BO" && a !== "24Hrs");
    } else if (props.isHide24hrs) {
      filteredAvailability = AVAILABILITY.filter((a) => a !== "24Hrs");
    } else {
      filteredAvailability = AVAILABILITY;
    }

    // 🟢 Only apply prefs if they have something, else fallback

    setColumns(COLUMNS);
    setBrands(BRANDS);
    setPrice(filteredPrices);
    setAvailability(filteredAvailability);
    setShowAlternate(true);


    let data: any = {
      visibleColumns: COLUMNS,
      brandFilter: BRANDS,
      priceColumnVisibility: filteredPrices,
      availabilityColumnVisibility: filteredAvailability,
      alternatePartsToggle: true,
    };
    props.onApplyFilter(data);

  };

  const handleProceed = () => {
    resetPreference(); // reset filters to default
    setOpen(false);
  };

  useEffect(() => {
    if (window.location.pathname === "/annexurecreateenquiry") {
      setShowAlternateBtn(false);
    } else if (window.location.pathname === "/createenquiry") {
      setShowAlternateBtn(true);
    }
  }, []);

  return (
    <Paper
      elevation={5}
      style={{
        position: "absolute",
        top: 56,
        right: 0,
        width: 400,
        padding: 16,
        zIndex: 10,
      }}
    >
      <h5>Column Filter</h5>
      <div className={classes.formContainer}>
        <div>
          {renderDropdown("Column", columns, setColumns, COLUMNS)}
          {renderDropdown("Brand", brands, setBrands, BRANDS)}
          {renderDropdown("Price", price, setPrice, filteredPrices)}
          {renderDropdown("Availability", availability, setAvailability, filteredAvailability)}
        </div>

        {showAlternateBtn && props.isOESOEM && (
          <div className={classes.toggleSwitch}>
            <div className="font-size-20 font-bold px-2">Show Alternates</div>
            <AntSwitch
              checked={showAlternate}
              onChange={() => {
                props.onApplyFilter({
                  visibleColumns: columns,
                  brandFilter: brands,
                  priceColumnVisibility: price,
                  availabilityColumnVisibility: availability,
                  alternatePartsToggle: !showAlternate,
                });
                setShowAlternate(!showAlternate);
              }}
            />
          </div>
        )}

        <div className="d-flex">
          <Button variant="contained"
            className={classes.saveButton}
            color="primary"
            endIcon={
              <Tooltip title="You can save your filter preferences" classes={{ tooltip: classes.tooltip }} arrow>
                <InfoOutlinedIcon />
              </Tooltip>
            }
            onClick={savePreferences}>
            Save settings
          </Button>

          <Button variant="contained"
            className={classes.resetButton}
            endIcon={
              <Tooltip title="You can reset the filters to default" classes={{ tooltip: classes.tooltip }} arrow>
                <InfoOutlinedIcon style={{ color: "white" }} />
              </Tooltip>
            }
            onClick={handleClickOpen}>
            {/* // onClick={resetPreference} */}
            Reset
          </Button>
          <Dialog
            open={open}
            onClose={(event, reason) => {
              if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                handleClose();
              }
            }}
            aria-labelledby="reset-dialog-title"
            aria-describedby="reset-dialog-description"
          >
            <DialogTitle id="reset-dialog-title">
              <div className={`${classes.header}`}>
                Confirm Reset
              </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText component="span" id="reset-dialog-description">
                <div className={`${classes.resetText}`}>
                  By clicking, the saved filters will be lost.
                  Are you sure you want to reset?
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={`mx-4 ${classes.yes}`} onClick={handleProceed}>
                Proceed
              </Button>
              <Button className={`mr-4 ${classes.cancel}`} onClick={handleClose} >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </Paper >
  );
}
